import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { takeUntil } from "rxjs/operators";
import { Subject } from 'rxjs';
import { Store } from "@ngrx/store";
import { Location } from '@angular/common';
import { ValidationUtil, VALIDATION_MESSAGES } from '../../../../utils/validation.util';

import {
    GetAsOfVersionStartAction,
    GetDocumentVersionDetails,
    DownloadDocument,
    GetDocumentById,
    GetCollaborators,
    GetViewers,
    GetSharedUsersList,
    GetUserCapabilitesOfDocument,
    PublishDocument,
    UnPublishDocument,
    getComments,
    postComment,
    GetActivityLog,
    RequestDocAccess,
    GetRequestDocAccessList,
    GetUnpublishedDocuments,
    ReplaceDocument,
    MarkPublicDocument
} from "../_store/resources.actions";

import {
    Validators,
    FormBuilder,
    FormGroup,
    FormArray,
    FormControl,
} from '@angular/forms';

import { AppState } from "../../../../app.reducer";





@Component({
    selector: 'app-replace-document',
    templateUrl: './replace-document.component.html',
    styleUrls: ['./replace-document.component.scss']
})
export class ReplaceDocumentComponent implements OnInit {

    documentId: string = '';
    replaceDocumentId: string = '';
    form: FormGroup;
    docDetail: any;
    versions$;

    selectedVersion: any = {
        version: "",
        status: "",
        updatedAt: "",
        versionNum: ""
    };
    SelectedVersion: any = {};

    private stopper: Subject<any> = new Subject();
    documentObj: any = {};
    MaxSizeAllowed: number;
    folderId: any;
    citisFolderId: any;
    constructor(
        public location: Location,
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private store: Store<AppState>,
    ) {

        this.form = this.fb.group({
            name: ['', [Validators.pattern('(.*)([a-zA-Z0-9])(.*)$')]],
            description: [''],
            tags: [''],
            folderId: null
        });
    }

    ngOnInit() {

        this.form.controls.description.valueChanges.subscribe((val) => { console.log(this.form.controls.description) })


        this.route.params.pipe(takeUntil(this.stopper)).subscribe(params => {
            this.documentId = params.documentId;
            this.replaceDocumentId = params.replaceDocId;
            this.citisFolderId = params.folderId;

            console.log(this.documentId);
            console.log(this.replaceDocumentId);

            this.store.dispatch(new GetDocumentById(this.replaceDocumentId));
            this.store.dispatch(new GetAsOfVersionStartAction(this.replaceDocumentId));

            this.store.select(state => state.resources.docDetail).subscribe(detail => {
                console.log(detail);
                this.docDetail = detail;
                this.form.patchValue({
                    name: detail.name || '',
                    description: detail.description || '',
                });
            });
            this.store.select(state => state.resources.asofVersion).subscribe(response => {
                this.versions$ = response;
                this.selectedVersion = this.versions$[0];
            });

            this.store.select(state => state.configurations.configurations).pipe(takeUntil(this.stopper)).subscribe((resp: any) => {
                if (Object.keys(resp).length) {
                  this.documentObj = Object.assign({}, resp);
                  this.documentObj['documentName'] = resp['docNameLength'].displayName;
                  this.documentObj['documentNameLength'] = parseInt(resp['docNameLength'].value);
                  this.documentObj['documentDescriptionSize']= parseInt(resp['docDescriptionSize'].value);
                  // tslint:disable-next-line:radix
                  const validators = [Validators.maxLength(parseInt(resp['docNameLength'].value))];
                  const docNameValidator = [ Validators.maxLength(parseInt(resp['docDescriptionSize'].value))]
                  this.form.get('name').setValidators([Validators.required, ValidationUtil.cannotBeBlank,
                  Validators.pattern('(.*)([a-zA-Z0-9])(.*)$'),
                    ...validators]);
                  this.form.get('description').setValidators([ ...docNameValidator]);
                }
              });

        });
    }


    onReplace() {
        this.form.value.folderId = (this.citisFolderId && this.citisFolderId != 'undefined' && this.citisFolderId != undefined) ? this.citisFolderId : null;
        const params = {
            id: this.documentId,
            replaceDocId: this.replaceDocumentId,
            folderId: (this.citisFolderId && this.citisFolderId != 'undefined' && this.citisFolderId != undefined) ? this.citisFolderId : null
        }
        console.log(this.form.value)
        this.store.dispatch(new ReplaceDocument(params, this.form.value));
    }

    onCancel() {
        this.location.back();
    }

    onVersionSelect(version) {
        console.log(version);
        this.documentId = version._id;
        this.store.dispatch(new GetDocumentById(version._id));
    }

}
